<div *ngIf="datatable.collapsing" 
    class='collapseData text-center'
    [ngClass]="collapseData[i] && collapseData[i].canCollapse ? 'collapseData-hover': ''"
    (click)="toggleCollapseData(i)"
>
    <a href="javascript:void(0);"
        *ngIf="collapseData[i] && collapseData[i].canCollapse"
        >
        <i class='fa-lg far' 
        [ngClass]="collapseData[i] && !collapseData[i].open ? 'fa-plus-square' : 'fa-minus-square'"
        ></i>
    </a>
</div>